var REACT_ELEMENT_TYPE;function _jsx(e, r, E, l) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var o = e && e.defaultProps,n = arguments.length - 3;if (r || 0 === n || (r = { children: void 0 }), 1 === n) r.children = l;else if (n > 1) {for (var t = Array(n), f = 0; f < n; f++) t[f] = arguments[f + 3];r.children = t;}if (r && o) for (var i in o) void 0 === r[i] && (r[i] = o[i]);else r || (r = o || {});return { $$typeof: REACT_ELEMENT_TYPE, type: e, key: void 0 === E ? null : "" + E, ref: null, props: r, _owner: null };}import PropTypes from 'prop-types';
import React from 'react';

import { LookupMultiSelect, Switcher } from "../../ReactReduxForms";

const SelectFilter = ({
  onChange = () => {},
  model,
  label = '',
  options = [],
  prefix = '',
  showBoolSwitch = false,
  sort = false,
  lookup = null,
  totalPossibleOptions = 0,
  allowSelectGroup = false
}) => /*#__PURE__*/
_jsx("ul", { className: "search__filter is-active" }, void 0, /*#__PURE__*/
_jsx("li", {}, void 0,
label,
showBoolSwitch && /*#__PURE__*/_jsx(Switcher, { model: `${model}.and`, prefix: prefix, onChange: onChange })
), /*#__PURE__*/
_jsx("li", { className: "wide" }, void 0, /*#__PURE__*/
_jsx(LookupMultiSelect, {
  model: `${model}.values`,
  prefix: prefix,
  options: options,
  onChange: onChange,
  sort: sort,
  lookup: lookup,
  totalPossibleOptions: totalPossibleOptions,
  allowSelectGroup: allowSelectGroup }
)
)
);















export default SelectFilter;